module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/components/UnavailableBattle/images/bg-fort-battle.6bcdde16.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/UnavailableBattle/images/bg-fort-battle.png
// module id = 2528
// module chunks = 11